import { useState, useEffect, useCallback } from 'react'

export default function useNotifications(userId) {
  const [notifications, setNotifications] = useState([])

  const onMarkSeen = useCallback((notificationId) => () => {
    setNotifications((notifications) => (
      notifications.filter(({ id }) => id != notificationId)
    ))

    fetch(`/rest/v2/notification/${notificationId}`, {
      credentials: 'same-origin',
      method: 'PUT'
    })
  }, [notifications])

  useEffect(() => {
    fetch(`/rest/v2/notification`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then(({ data }) => setNotifications(data.map((notification) => ({
        ...notification,
        markSeen: onMarkSeen(notification.id)
      }))))
  }, [])

  return notifications
}
